import { render, staticRenderFns } from "./jsaOnePage.vue?vue&type=template&id=9936c3ee"
import script from "./jsaOnePage.vue?vue&type=script&lang=js"
export * from "./jsaOnePage.vue?vue&type=script&lang=js"
import style0 from "./jsaOnePage.vue?vue&type=style&index=0&id=9936c3ee&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9936c3ee')) {
      api.createRecord('9936c3ee', component.options)
    } else {
      api.reload('9936c3ee', component.options)
    }
    module.hot.accept("./jsaOnePage.vue?vue&type=template&id=9936c3ee", function () {
      api.rerender('9936c3ee', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/ram/jsa/jsaOnePage.vue"
export default component.exports